export function roleWisePermissions(type) {
  /**
   * Permissions -
   *
   * 'manage-voucher',
   * 'manage-payment-settings',
   * 'manage-countries'
   * 'refund-booking',
   * 'manage-app-version',
   * 'manage-coupons'
   * 'manage-booking-price'
   * 'manage-notofication'
   * 'manage-journeys'
   * 'book-cruise'
   * 'check-user-otp'
   * 'withdraw-wallet
   * 'contract-files'
   * 'manage-meta-tags'
   * 'create-delete-meta-tag-for-pages'
   * 'create-account'
   * 'edit-commission
   * 'view_user_activities'
   * 'annual-report'
   * 'concierge-chalet-book'
   *
   * settings
   * settings-services
   * service-categories
   */

  let data = {
    'super-admin': [
      'manage-voucher',
      'manage-payment-settings',
      'manage-countries',
      'refund-booking',
      'manage-app-version',
      'manage-booking-price',
      'manage-coupons',
      'manage-notofication',
      'manage-journeys',
      'book-cruise',
      'check-user-otp',
      'withdraw-wallet',
      'contract-files',
      'manage-meta-tags',
      'create-account',
      'create-delete-meta-tag-for-pages',
      'check-tamara-limit',
      'edit-commission',
      'view_user_activities',
      'annual-report',
      'client-setting',
      'concierge-chalet-book',
      'view-admin-review',
      'add-admin-review',
      'edit-admin-review',
      'delete-admin-review',
      'settings-services',
      'settings',
      'service-categories',
    ],
    owners: ['manage-voucher', 'refund-booking', 'manage-booking-price', 'create-account', 'edit-admin-review', 'delete-admin-review', 'view-admin-review'],
    'finance-member': [
      'manage-voucher',
      'refund-booking',
      'manage-booking-price',
      'withdraw-wallet',
      'contract-files',
      'annual-report',
      'edit-commission'
    ],
    'finance-mgr': [
      'manage-voucher',
      'refund-booking',
      'manage-booking-price',
      'withdraw-wallet',
      'contract-files',
      'annual-report',
      'edit-commission'
    ],
    'sales-member': [],
    'sales-mgr': [],
    'mkt-coord': ['contract-files', 'manage-meta-tags'],
    'mkt-mgr': ['contract-files', 'manage-meta-tags', 'client-setting', 'create-delete-meta-tag-for-pages'],
    'ops-sup': [
      'manage-booking-price',
      'check-user-otp',
      'create-account',
      'edit-commission',
      'settings-services',
      'service-categories',
      'edit-admin-review',
      'delete-admin-review',
      'view-admin-review',
    ],
    'ops-coord': ['create-account', 'edit-commission', 'view-admin-review',],
    'chalet-owner': [],
    'event-vendor': [],
    concierge: ['book-cruise'],
    vendor: [],
    store: [],
    admin: [],
    captain: [],
    user: [],
    'car-owner': [],
    'third-party': [],
    'wego-admin': [],
    // below roles are not used
    'sr-ops-coord': [],
    'ops-mgr': [],
    'port-admin': [],
  }

  return data[type]
}
